/* Upcart is preferred; the rendered Shopify cart remains the fallback. */
(function (root) {
  'use strict';

  var WAIT_MS = 1500;
  var POLL_MS = 50;
  var NATIVE_KEY = 'nc_native_cart';
  var RETURN_KEY = 'nc_native_cart_return_v1';

  function cartPath(target) {
    return (target.NCUpcartBoot || {}).cartPath || '/cart';
  }

  function cartRoot(target) {
    try {
      var scope = target.upcartDocumentOrShadowRoot;
      if (typeof scope === 'function') scope = scope.call(target);
      return scope && typeof scope.querySelector === 'function' ? scope : target.document;
    } catch (error) { return target.document; }
  }

  function isCartPagePath(path, base) {
    function normalize(value) { return String(value).replace(/\/+$/, '') || '/'; }
    return normalize(path) === normalize(base || '/cart') || normalize(path) === '/cart';
  }

  function isOpen(target) {
    try {
      var scope = cartRoot(target);
      var drawer = scope.querySelector('#CartPopup.styles_active__');
      if (!drawer || drawer.getAttribute('aria-hidden') === 'true') return false;
      var style = target.getComputedStyle(drawer);
      var rect = drawer.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' &&
        Number(style.opacity) !== 0 && rect.width > 0 && rect.height > 0 &&
        rect.right > 0 && rect.bottom > 0 && rect.left < target.innerWidth && rect.top < target.innerHeight;
    } catch (error) { return false; }
  }

  function mountedDrawer(target) {
    try {
      var scope = cartRoot(target);
      var drawer = scope.querySelector('#CartPopup'), backdrop = scope.querySelector('#UpcartPopupBackDrop');
      return drawer && backdrop && drawer.isConnected !== false && backdrop.isConnected !== false;
    } catch (error) { return false; }
  }

  function nativeSnapshot(target) {
    var styles = [];
    [target.document.documentElement, target.document.body].forEach(function (node) {
      if (!node || !node.style) return;
      ['overflow', 'overflow-x', 'overflow-y', 'position', 'top', 'padding-right'].forEach(function (name) {
        styles.push([node, name, node.style.getPropertyValue(name), node.style.getPropertyPriority(name)]);
      });
    });
    return { focus: target.document.activeElement, x: target.scrollX, y: target.scrollY, styles: styles };
  }

  // Once fallback is selected, late app work must not cover, focus or lock the
  // native cart. This guard changes only app containers and app-owned locks.
  // It never replaces vendor hooks, intercepts requests or filters analytics.
  function useNative(target, snapshot) {
    markNative(target, true);
    target.__ncUpcartRestorePending = null;
    if (target.__ncNativeGuard) return;
    var guard = { nodes: new Map(), scopes: new Set(), observers: [], listeners: [],
      snapshot: snapshot || nativeSnapshot(target), restoring: false, lastClose: null, wasActive: false, first: true };
    target.__ncNativeGuard = guard;
    function listen(node, name, handler, options) {
      node.addEventListener(name, handler, options);
      guard.listeners.push(function () { node.removeEventListener(name, handler, options); });
    }
    function watch(scope) {
      if (!scope || guard.scopes.has(scope) || !target.MutationObserver) return;
      guard.scopes.add(scope);
      var observer = new target.MutationObserver(protect);
      observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'inert', 'aria-hidden'] });
      guard.observers.push(observer);
    }
    function appActive(scope) {
      var drawer = scope.querySelector('#CartPopup');
      var backdrop = scope.querySelector('#UpcartPopupBackDrop');
      return !!((drawer && drawer.classList.contains('styles_active__')) ||
        (backdrop && backdrop.classList.contains('styles_active__')) ||
        (target.document.body && (target.document.body.classList.contains('upcartPopupShow') || target.document.body.classList.contains('upcartScrollLocking-noScroll'))));
    }
    function block(node) {
      if (!node || !node.style) return;
      if (!guard.nodes.has(node)) guard.nodes.set(node, {
        display: node.style.getPropertyValue('display'), priority: node.style.getPropertyPriority('display'),
        inert: node.inert, hidden: node.getAttribute('aria-hidden')
      });
      if (node.style.getPropertyValue('display') !== 'none' || node.style.getPropertyPriority('display') !== 'important') node.style.setProperty('display', 'none', 'important');
      if (!node.inert) node.inert = true;
      if (node.getAttribute('aria-hidden') !== 'true') node.setAttribute('aria-hidden', 'true');
    }
    function insideApp(node) {
      if (!node || typeof node.nodeType !== 'number') return false;
      for (var entry of guard.nodes.keys()) if (entry === node || entry.contains(node)) return true;
      if (node && node.closest && node.closest('#CartPopup, #UpcartPopup, #UpcartPopupBackDrop')) return true;
      var scope = cartRoot(target);
      if (scope && scope.host && (scope.host === node || scope.contains(node))) return true;
      return false;
    }
    function restorePosition() {
      if (guard.restoring) return;
      guard.restoring = true;
      try {
        var focus = guard.snapshot.focus;
        if (focus && focus.isConnected && !insideApp(focus) && target.document.activeElement !== focus) focus.focus({ preventScroll: true });
        if (target.scrollX !== guard.snapshot.x || target.scrollY !== guard.snapshot.y) target.scrollTo(guard.snapshot.x, guard.snapshot.y);
      } catch (error) {} finally { guard.restoring = false; }
    }
    function protect() {
      if (target.__ncNativeGuard !== guard || guard.protecting) return;
      guard.protecting = true;
      try {
      var scope = cartRoot(target);
      var active = appActive(scope);
      watch(scope);
      block(scope.host);
      ['#UpcartPopup', '#CartPopup', '#UpcartPopupBackDrop'].forEach(function (selector) { block(scope.querySelector(selector)); });
      if (active && (!guard.wasActive || guard.lastClose !== target.upcartCloseCart)) {
        guard.lastClose = target.upcartCloseCart;
        try { if (typeof guard.lastClose === 'function') guard.lastClose(); } catch (error) {}
      }
      guard.wasActive = appActive(scope);
      if (active || guard.first) {
        ['#CartPopup', '#UpcartPopupBackDrop'].forEach(function (selector) {
          var node = scope.querySelector(selector);
          if (node) node.classList.remove('styles_active__');
        });
        [target.document.body, scope.querySelector('#UpcartPopup')].forEach(function (node) {
          if (!node) return;
          node.classList.remove('upcartPopupShow', 'upcartScrollLocking-noScroll');
        });
        guard.snapshot.styles.forEach(function (item) {
          if (item[0].style.getPropertyValue(item[1]) !== item[2] || item[0].style.getPropertyPriority(item[1]) !== item[3]) {
            if (item[2]) item[0].style.setProperty(item[1], item[2], item[3]); else item[0].style.removeProperty(item[1]);
          }
        });
        restorePosition();
        guard.ignoreScroll = true;
        if (!guard.restoreQueued) {
          guard.restoreQueued = true;
          target.setTimeout(function () {
            if (target.__ncNativeGuard === guard) restorePosition();
            guard.ignoreScroll = false; guard.restoreQueued = false;
          }, 0);
        }
      }
      guard.first = false;
      } finally { guard.protecting = false; }
    }
    listen(target.document, 'focusin', function (event) {
      if (guard.restoring || guard.protecting) return;
      var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
      if (path.some(insideApp)) { protect(); restorePosition(); }
      else if (event.target !== target.document.body && event.target !== target.document.documentElement) guard.snapshot.focus = event.target;
    }, true);
    listen(target, 'scroll', function () {
      if (!guard.restoring && !guard.protecting && !guard.ignoreScroll && !appActive(cartRoot(target))) {
        guard.snapshot.x = target.scrollX; guard.snapshot.y = target.scrollY;
      }
    }, true);
    watch(target.document);
    // Also finds a ShadowRoot that the app exposes after its host was inserted.
    guard.timer = target.setInterval(protect, 250);
    protect();
  }

  function releaseNative(target) {
    var guard = target.__ncNativeGuard;
    if (!guard) return;
    target.__ncNativeGuard = null;
    target.clearInterval(guard.timer);
    guard.observers.forEach(function (observer) { observer.disconnect(); });
    guard.listeners.forEach(function (remove) { remove(); });
    guard.nodes.forEach(function (value, node) {
      if (value.display) node.style.setProperty('display', value.display, value.priority); else node.style.removeProperty('display');
      node.inert = value.inert;
      if (value.hidden === null) node.removeAttribute('aria-hidden'); else node.setAttribute('aria-hidden', value.hidden);
    });
  }

  function cancel(target, keepLocked) {
    var attempt = target.__ncUpcartAttempt;
    if (!attempt) return;
    var remember = keepLocked == null && attempt.onCart;
    if (keepLocked == null) keepLocked = attempt.onCart && attempt.called;
    attempt.done = true;
    target.clearInterval(attempt.timer);
    if (attempt.scrollListener) target.removeEventListener('scroll', attempt.scrollListener, true);
    target.__ncUpcartAttempt = null;
    if (keepLocked || remember) target.__ncUpcartRestorePending = attempt;
    if (!keepLocked && attempt.unlock) attempt.unlock();
  }

  function nativeDestination(target, href) {
    var url = new URL(href || cartPath(target), target.location.href);
    var current = new URL(target.location.href);
    if (!url.searchParams.has('preview_theme_id') && current.searchParams.has('preview_theme_id')) {
      url.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
    }
    url.searchParams.set(NATIVE_KEY, '1');
    return url.pathname + url.search + url.hash;
  }

  function markNative(target, native) {
    try {
      var current = new URL(target.location.href);
      if (native) current.searchParams.set(NATIVE_KEY, '1');
      else current.searchParams.delete(NATIVE_KEY);
      target.history.replaceState(target.history.state, '', current.pathname + current.search + current.hash);
    } catch (error) {}
  }

  function nativeReferrer(target) {
    try {
      var previous = new URL(target.document.referrer);
      return previous.origin === target.location.origin && isCartPagePath(previous.pathname, cartPath(target)) &&
        previous.searchParams.get(NATIVE_KEY) === '1';
    } catch (error) { return false; }
  }

  function consumeNativeReturn(target) {
    try {
      var expires = Number(target.sessionStorage.getItem(RETURN_KEY));
      target.sessionStorage.removeItem(RETURN_KEY);
      return expires > target.Date.now() && expires <= target.Date.now() + 10000;
    } catch (error) { return false; }
  }

  function settleCancelledNavigation(target, event, sameDocument) {
    target.setTimeout(function () {
      if (target.__ncUpcartRestorePending && (sameDocument || event.defaultPrevented)) {
        var attempt = target.__ncUpcartRestorePending;
        if (attempt.unlock) attempt.unlock();
        useNative(target, attempt.snapshot);
      }
    }, 0);
  }

  function openWhenReady(target, href, explicit) {
    if (target.__ncUpcartAttempt || target.__ncUpcartRestorePending || isOpen(target)) return;
    var attempt = { done: false, called: false, deadline: target.Date.now() + WAIT_MS, timer: null };
    var onCart = isCartPagePath(target.location.pathname, cartPath(target));
    attempt.onCart = onCart;
    if (onCart) {
      var nativeCart = target.document.querySelector('nc-cart');
      // Never take over an edit already started before this deferred script ran.
      if (!nativeCart || !('inert' in nativeCart) || (!explicit && nativeCart.contains(target.document.activeElement))) return;
      releaseNative(target);
      attempt.snapshot = nativeSnapshot(target);
      attempt.scrollListener = function () {
        var body = target.document.body;
        if (!isOpen(target) && !(body && (body.classList.contains('upcartPopupShow') || body.classList.contains('upcartScrollLocking-noScroll')))) {
          attempt.snapshot.x = target.scrollX; attempt.snapshot.y = target.scrollY;
        }
      };
      target.addEventListener('scroll', attempt.scrollListener, true);
      var previousInert = nativeCart.inert;
      var previousBusy = nativeCart.getAttribute('aria-busy');
      nativeCart.inert = true;
      nativeCart.setAttribute('aria-busy', 'true');
      attempt.unlock = function () {
        // An Upcart write can start while this opening attempt is finishing.
        // Its stale native controls stay locked until the sync commits.
        if (target.__ncNativeCartSync && target.__ncNativeCartSync.dirty) {
          nativeCart.inert = true;
          nativeCart.setAttribute('aria-busy', 'true');
          return;
        }
        nativeCart.inert = previousInert;
        if (previousBusy === null) nativeCart.removeAttribute('aria-busy');
        else nativeCart.setAttribute('aria-busy', previousBusy);
      };
    }
    target.__ncUpcartAttempt = attempt;

    function finish(failed) {
      if (attempt.done) return;
      cancel(target, false);
      if (failed) {
        if (onCart) { useNative(target, attempt.snapshot); return; }
        var destination = nativeDestination(target, onCart ? target.location.href : href);
        target.location.assign(destination);
      }
    }

    function check() {
      if (attempt.done) return;
      if (isOpen(target)) { finish(false); return; }
      if (target.Date.now() >= attempt.deadline) { finish(true); return; }
      if (!attempt.called && mountedDrawer(target) && typeof target.upcartOpenCart === 'function') {
        attempt.called = true;
        try {
          var result = target.upcartOpenCart();
          if (result && typeof result.then === 'function') {
            result.then(function () {}, function () { finish(!isOpen(target)); });
          }
        } catch (error) { finish(!isOpen(target)); return; }
        if (isOpen(target)) finish(false);
      }
    }

    attempt.timer = target.setInterval(check, POLL_MS);
    check();
  }

  function handleClick(event, target) {
    if (!event || event.defaultPrevented || (event.button != null && event.button !== 0) ||
      event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    var node = event.target;
    var link = node && typeof node.closest === 'function' && node.closest('a[href]');
    if (!link || link.hasAttribute('download')) return false;
    var destination = link.getAttribute('target');
    if (destination && destination.toLowerCase() !== '_self') return false;
    var href = link.getAttribute('href');
    if (!href) return false;
    var url;
    try { url = new URL(href, target.location.href); } catch (error) { return false; }
    if (url.origin !== target.location.origin || !isCartPagePath(url.pathname, cartPath(target))) {
      cancel(target);
      settleCancelledNavigation(target, event, false);
      return false;
    }
    if (href.charAt(0) !== '#') {
      try { target.sessionStorage.removeItem(RETURN_KEY); } catch (error) {}
      if (isCartPagePath(target.location.pathname, cartPath(target))) {
        target.__ncNativeActionAt = 0;
        markNative(target, false);
      }
    }
    var keys = Array.from(url.searchParams.keys());
    if (keys.some(function (key) { return key !== 'preview_theme_id'; }) || url.hash) {
      cancel(target);
      var current = new URL(target.location.href);
      settleCancelledNavigation(target, event, url.pathname === current.pathname && url.search === current.search);
      return false;
    }
    event.preventDefault();
    openWhenReady(target, href, true);
    return true;
  }

  function start(target) {
    if (target.__ncUpcartStarted) return;
    target.__ncUpcartStarted = true;
    // Remove a flag left by the former redirect without acting on it.
    try { target.sessionStorage.removeItem('nc_open_upcart'); } catch (error) {}
    var returningToNative = consumeNativeReturn(target);
    target.addEventListener('pagehide', function () {
      if (target.__ncNativeActionAt && target.Date.now() - target.__ncNativeActionAt < 10000 &&
        new URL(target.location.href).searchParams.get(NATIVE_KEY) === '1') {
        try { target.sessionStorage.setItem(RETURN_KEY, String(target.Date.now() + 10000)); } catch (error) {}
      }
      cancel(target);
    });
    target.addEventListener('popstate', function (event) {
      cancel(target);
      settleCancelledNavigation(target, event, true);
    });
    target.addEventListener('pageshow', function (event) {
      if (event.persisted) consumeNativeReturn(target);
      if (event.persisted && target.__ncUpcartRestorePending) {
        var attempt = target.__ncUpcartRestorePending;
        if (attempt.unlock) attempt.unlock();
        useNative(target, attempt.snapshot);
      }
    });
    target.document.addEventListener('submit', function (event) {
      if (event.target && event.target.closest && event.target.closest('nc-cart')) target.__ncNativeActionAt = target.Date.now();
      cancel(target);
      settleCancelledNavigation(target, event, false);
    }, true);
    target.document.addEventListener('click', function (event) {
      target.__ncNativeActionAt = event.target && event.target.closest && event.target.closest('nc-cart') ? target.Date.now() : 0;
      handleClick(event, target);
    }, true);
    if (isCartPagePath(target.location.pathname, cartPath(target))) {
      if (new URL(target.location.href).searchParams.get(NATIVE_KEY) === '1' || returningToNative || nativeReferrer(target)) useNative(target);
      else openWhenReady(target);
    }
  }

  root.NCUpcartRedirect = {
    WAIT_MS: WAIT_MS,
    isCartPagePath: isCartPagePath,
    isOpen: isOpen,
    mountedDrawer: mountedDrawer,
    nativeDestination: nativeDestination,
    handleClick: handleClick,
    openWhenReady: openWhenReady,
    cancel: cancel,
    start: start
  };
  if (root.document && root.location && !root.__NC_UPCART_NO_BOOT) start(root);
})(typeof window !== 'undefined' ? window : globalThis);
